module.exports = __webpack_public_path__ + "static/media/slider-2.51fe5baa.jpg";